// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ACTION_TO_ADD_COMMENT = "p\u0159\u00edd\u00e1n\u00ed odpov\u011bdi";
export const ARE_YOU_SURE_YOU_WANT_TO_DELETE_COMMENT = "Opravdu chce\u0161 vymazat koment\u00e1\u0159?";
